import gql from 'graphql-tag';
import { kmsClient } from 'api';
import { useMutation } from '@apollo/react-hooks';
import { UpdatePublisherMutation, UpdatePublisherMutationVariables } from './__generated__/UpdatePublisherMutation';

const UPDATE_PUBLISHER_MUTATION = gql`
  mutation UpdatePublisherMutation($publisherInput: UpdatePublisherInput!) {
    updatePublisher(publisherInput: $publisherInput) {
      publisher {
        id
      }
      errors
    }
  }
`;

export const useUpdatePublisherMutation = () => {
  return useMutation<UpdatePublisherMutation, UpdatePublisherMutationVariables>(UPDATE_PUBLISHER_MUTATION, {
    client: kmsClient
  });
};
